import { Action } from "redux";

export const CHANGES_LOADING = "CHANGES_LOADING";

export const changesLoadingAction = (): Action => {
    return {
        type: CHANGES_LOADING,
    };
};
